import Action from "./comps/Action";
import Header from "./comps/Header";
import Price from "./comps/Price";
import Status from "./comps/Status";
import Details from "./comps/Details";
import FactorDetail from "./comps/FactorDetail";
import FactorSum from "./comps/FactorSum";
import Table from "components/Table2";
import Text from "components/Table2/CellComps/Text";
import PriceComp from "components/Table2/CellComps/Price";
import { useDispatch, useSelector } from "react-redux";
import Box from "./comps/Box";
import { SetStateAction, useEffect, useState } from "react";
// import { apiGetAccounting } from "../../../api/accountingApi";
import { apiDeleteFactors, apiGetFactor } from "../../../api/factorApi";
// import ExcelIcon from "assets/icons/ExcelIcon";
// import PdfIcon from "assets/icons/PdfIcon";
import PrinterIcon from "assets/icons/PrinterIcon";
import { useNavigate } from "react-router-dom";
import { addOpenDrawer, setConfirm } from "../../../store/actions/appAction";
import EditImg from "assets/images/Edit.svg";
import DeleteImg from "assets/images/Delete.svg";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import DrawerHistory from "./comps/DrawerHistory";
import {
  apiCreateNotifications,
  apiDeleteNotifications,
  apiEditNotifications,
  apiGetItemNotifications,
} from "api/notificationApi";
import { apiGetHistory, apiGetItemNote } from "api/noteApi";
import useCurrency from "helpers/useCurrency";

// const FactorContainer = styled("div")({
//   position: "fixed",
//   display: "none",
// });

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function FactorDrawer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { defCur } = useCurrency();

  const { drawerProps, anchor } = useSelector((state: any) => state).appReducer;
  const token = useSelector((state: any) => state).businessReducer.business?.token;

  const [factor, setFactor] = useState(drawerProps?.factor);
  const [rows, setRows] = useState([]);
  const [currency, setCurrency] = useState(defCur.en_title);
  const [notificationsList, setNotificationList] = useState([]);
  const [noteList, setNoteList] = useState([]);
  const [History, setHistory] = useState([]);
  // tabs state
  const [value, setValue] = useState(0);
  // ===state

  // tab function
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  // ---tabFunction

  // modal state
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  // ===modal state

  useEffect(() => {
    if (factor) {
      dispatch(
        // @ts-ignore
        apiGetFactor(factor.type_id ?? factor.id, factor.type, token, (factorObject: any) => {
          const newFactor = { ...factor, ...factorObject };
          renderTable(newFactor);
          setFactor(newFactor);
        })
      );

      dispatch(
        // @ts-ignore
        apiGetItemNotifications(
          token,
          factor.type_id ?? factor.id,
          "Factor",
          (value: SetStateAction<never[]>) => {
            setNotificationList(value);
          }
        )
      );
      initialNote();
    }
  }, []);

  const initialNote = () => {
    dispatch(
      // @ts-ignore
      apiGetItemNote(token, factor.type_id ?? factor.id, "Factor", (value: SetStateAction<never[]>) => {
        setNoteList(value);
      })
    );
    dispatch(
      // @ts-ignore
      apiGetHistory(token, factor.type_id ?? factor.id, "Factor", (value: SetStateAction<never[]>) => {
        setHistory(value);
      })
    );
  };

  if (!factor) return <></>;

  const renderTable = (factor: any) => {
    const rows: any = [];

    factor.Factor_Items.map((item: any) => {
      rows.push({
        label: item?.Product?.title,
        description: item?.description,
        quantity: item?.quantity,
        unit: item?.unit,
        price: item?.price,
        discount: item?.discount,
        tax: item?.tax,
        totalPrice: item?.finalPrice,
      });
    });

    setRows(rows);
    setCurrency(factor?.Currency?.en_title);
  };

  const details = [];
  // factor.date && details.push (`تاریخ ثبت سیستم:   ${factor.date}`);
  factor.date && details.push(`تاریخ صدور: ${factor.time} ${factor.date}`);
  factor.dueDate && details.push(`تاریخ سررسید: ${factor.dueDate}`);
  const closeDrawer = () => dispatch(addOpenDrawer(false, undefined, anchor));
  const editFactor = () => {
    closeDrawer();
    navigate(`/factors/${factor.type}/${factor.type_id ?? factor.id}`);
  };

  const deleteFactor = () => {
    closeDrawer();
    dispatch(
      // @ts-ignore
      setConfirm("حذف فاکتور", () =>
        dispatch(
          // @ts-ignore
          apiDeleteFactors([factor.type_id ?? factor.id], token, {
            key: factor.type,
          })
        )
      )
    );
  };

  const printFactor = () => {
    closeDrawer();
    navigate(`/factors/view?factorId=${factor.type_id ?? factor.id}&factorType=${factor.type}`);
  };

  // const excelExport = () => {};

  // const printPdf = () => {};

  const actions = {
    icons: [
      { Icon: PrinterIcon, onClick: printFactor },
      // {Icon: ExcelIcon, onClick: excelExport},
      // {Icon: PdfIcon, onClick: printPdf}
    ],
    menu: [
      {
        label: "ویرایش",
        icon: <img src={EditImg} alt="" />,
        onClick: editFactor,
        show: true,
      },
      {
        Label: <span style={{ color: "#F42222", fontSize: "12px", fontWeight: 700 }}>حذف</span>,
        icon: <img src={DeleteImg} alt="" />,
        onClick: deleteFactor,
        show: true,
      },
    ],
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const submitNotification = (value: any) => {
    dispatch(
      // @ts-ignore
      apiCreateNotifications(
        token,
        factor.type_id ?? factor.id,
        "Factor",
        value?.title,
        value?.description,
        value.fireDate,
        () => {
          dispatch(
            // @ts-ignore
            apiGetItemNotifications(
              token,
              factor.type_id ?? factor.id,
              "Factor",
              (value: SetStateAction<never[]>) => {
                setNotificationList(value);
              }
            )
          );
          handleCloseModal();
        }
      )
    );
  };

  const handleDeleteNotification = (id: any) => {
    dispatch(
      // @ts-ignore
      apiDeleteNotifications(token, id, () => {
        dispatch(
          // @ts-ignore
          apiGetItemNotifications(
            token,
            factor.type_id ?? factor.id,
            "Factor",
            (value: SetStateAction<never[]>) => {
              setNotificationList(value);
            }
          )
        );
      })
    );
  };

  const handelChangeActive = (value: any) => {
    dispatch(
      // @ts-ignore
      apiEditNotifications(token, value?.id, value.active, () => {
        dispatch(
          // @ts-ignore
          apiGetItemNotifications(
            token,
            factor.type_id ?? factor.id,
            "Factor",
            (value: SetStateAction<never[]>) => {
              setNotificationList(value);
            }
          )
        );
      })
    );
  };

  return (
    <div style={{ backgroundColor: "#FCFEFF", height: "100vh" }}>
      <Header heading={factor.title} id={`${factor.accountingCode}`} />
      <Action
        reminderData={notificationsList}
        actions={actions}
        side={<div></div>}
        withReminder
        fireDate={factor.dueDate}
        submitNotification={(value) => {
          submitNotification(value);
        }}
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        handleOpenModal={handleOpenModal}
        deleteItem={(id) => handleDeleteNotification(id)}
        updateNotification={(val) => handelChangeActive(val)}
      />
      <div style={{ padding: "16px 32px" }}>
        <div style={{ display: "flex", gap: 16 }}>
          <Price price={factor.totalPrice} currency={factor.Currency} />
          <Status title={factor.status} status={factor.status === "تایید شده" ? "success" : "error"} />
        </div>
        <Details details={details} />

        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="خلاصه" {...a11yProps(0)} />
          <Tab label="تاریخچه / یادداشت" {...a11yProps(1)} />
        </Tabs>

        <TabPanel value={value} index={0}>
          <FactorDetail factor={factor} />
          <div style={{ height: 24 }} />

          <Table
            headers={[
              { label: "کالا" },
              { label: "شرح" },
              { label: "مقدار" },
              { label: "مبلغ واحد" },
              { label: "تخفیف" },
              { label: "مالیات" },
              { label: "مبلغ کل" },
            ]}
            cols={[
              { Comp: Text, key: "label" },
              {
                Comp: Text,
                key: "description",
                getValue: (item) => (
                  <div className="max-w-[150px] whitespace-normal">
                    <span>{item.description}</span>
                  </div>
                ),
              },
              {
                Comp: Text,
                key: "quantity",
                getValue: (item) => (
                  <div className="flex items-center gap-2">
                    <span className="text-dark-3 text-xs">{item.unit}</span>
                    <span className="text-dark-1 text-sm font-bold">{item.quantity}</span>
                  </div>
                ),
              },
              { Comp: PriceComp, key: "price", options: { currency } },
              { Comp: PriceComp, key: "discount", options: { currency } },
              { Comp: PriceComp, key: "tax", options: { currency } },
              { Comp: PriceComp, key: "totalPrice", options: { currency } },
            ]}
            headerColor="#fff"
            rows={rows}
            withoutMenu
          />
          <div style={{ height: 24 }} />
          <FactorSum factor={factor} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <DrawerHistory
            title={"فاکتور"}
            history={History}
            noteList={noteList}
            token={token}
            detail_type="Factor"
            id={factor.type_id ?? factor.id}
            refresh={() => {
              initialNote();
            }}
          />
        </TabPanel>
      </div>
    </div>
  );
}
